import WebServiceRequest from '../Api/WebServiceRequest'

class SmartMonthlyReport extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('SmartMonthlyViewReport/Get')
    }

}
class SmartMostPageViewReport extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('SmartMostPageViewReport/Get')
    }

}

class SmartMostViewItemReport extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('SmartMostViewItemReport/Get')
    }
    setParams(data){
        super.setRequestParam(data)
    }
}
class SmartOnlineChatReport extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('SmartOnlineChatReport/Get')
    }
}


class SmartReportHeader extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('SmartReportHeader/Get')
    }
}

class SmartSaleMonthlyReport extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('SmartSaleMonthlyReport/Get')
    }

}

class SmartSaleDailyReport extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('SmartSaleDailyReport/Get')
    }

}
class SmartDailyReport extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('SmartDailyViewReport/Get')
    }

}
class GetTodayBirthDay extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Users/GetTodayBirthDay')
    }

}
class GetProductInstapageUser extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('ProductInstapageUser/Get')
    }
    setParams(data){
        super.setRequestParam(data)
    }

}
class ProductInstapageUserCourses extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('ProductInstapageUser/GetCourseList')
    }

}




export {
    SmartDailyReport,
    SmartSaleDailyReport,
    SmartSaleMonthlyReport,
    SmartReportHeader,
    SmartOnlineChatReport,
    SmartMostViewItemReport,
    SmartMostPageViewReport,
    SmartMonthlyReport,
    GetTodayBirthDay,
    GetProductInstapageUser,
    ProductInstapageUserCourses
};
